import ahoy from "ahoy.js";

(function() {
    $(document).on("click", ".js--show-phone", function() {
        let data = $(this).data("phone");
        let decrypted_phone = atob(data);
        $(this).replaceWith(decrypted_phone);
        let event_name = "Click on Show Phone in Header";
        window.gtag('event', event_name, {
            'event_category': 'Phone',
        });
        window.ym(window.ym_id, 'reachGoal', event_name);
        ahoy.track(event_name);
    })
})();